import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-allergy',
    templateUrl: './allergy.component.html',
    styleUrls: ['./allergy.component.css'],
    standalone: false
})
export class AllergyComponent implements OnInit {
  selected: string = '';
  medlist: any[] = [];
  allergReactions: any[] = [];
  insuranceList: any[] = [];
  allergyList: any[] = [];
  immunizationList: any[] = [];
  medconList:any[]=[];
  famHistoryList:any[]=[];
  searchText: string = '';
  titleMap: { [key: string]: string } = {
    familyhistory: 'Family History',
    medicalcondition: 'Medical Condition'
  };

  constructor(
    private router: Router,
    private route : ActivatedRoute,
    private authService: AuthService,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params:any) => {
      this.selected = params.get('type') || '';
      //console.log('Selected type from route:', this.selected);
    });
  
    
    this.loadProfileDetails();
  }

  get headerTitle(): string {
  const titles: { [key: string]: string } = {
    allergy: 'Allergy',
    insurance: 'Insurance',
    immunization: 'Immunization',
    familyhistory: 'Family History',
    medicalcondition: 'Medical Conditions',
  };
  return titles[this.selected] || 'List Of Medications';
}

   get filteredList(): any[] {
    const listMap: { [key: string]: any[] } = {
      insurance: this.insuranceList,
      allergy: this.allergyList,
      immunization: this.immunizationList,
      medicalcondition: this.medconList,
      familyhistory: this.famHistoryList
    };

    const currentList = listMap[this.selected] || [];

    if (!this.searchText?.trim()) return currentList;

    const search = this.searchText.toLowerCase();
    return currentList.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(search)
      )
    );
  }

  convertDateFormat(dateString: string): string {
    if (!dateString) return '';
    
    const [month, day, year] = dateString.split('-');
    return `${day}-${month}-${year}`;
  }

  /** Loads user profile data and maps to the respective selected tab. */
  private loadProfileDetails(): void {
    if (!this.selected) return;

    this.authService.profile_details_cat(this.selected).subscribe({
      next: (res: any) => {
        const data = res?.data;
        // console.log('data',data)

        switch (this.selected) {
          case 'insurance':
            this.insuranceList = data?.insurance.reverse() || [];
            break;
          case 'allergy':
            this.allergyList = data?.allergy.reverse() || [];
            break;
          case 'immunization':
            this.immunizationList = data?.immunization.reverse() || [];
            break;
          case 'medicalcondition':
            this.medconList = data?.medicalCondition.reverse() || [];
            break;
          case 'familyhistory':
            this.famHistoryList = data?.familyHistory.reverse() || [];
            break;
            
          default:
            break;
        }
      },
      error: () => this.toastr.error('Failed to load profile details')
    });
  }

  logIcons: any = {
    insurance: 'assets/images/health/icons/insurance-shield.svg',
    familyhistory: 'assets/images/health/healthlogico/familyhispng.png',
    medicalcondition: 'assets/images/health/icons/med-rep.png',
    allergy: 'assets/images/health/icons/allergies 1(1).svg',
    immunization: 'assets/images/health/healthlogico/immunization.png'
  };

  getLogTitle(selected: any) {
    const titles: any = {
      insurance: 'Insurance',
      familyhistory: 'Family History',
      medicalcondition: 'Medical Condition',
      allergy: 'Allergy',
      immunization: 'Immunizations'
    };
    return titles[selected] || '';
  }

  getBtnTitle(selected: string): string {
    const titles: any = {
      insurance: 'Insurance',
      familyhistory: 'Family History',
      medicalcondition: 'Medical Condition',
      allergy: 'Allergy',
      immunization: 'Immunization'
    };
    return titles[selected] || '';
  }



//   getLogTitle(selected: string): string {
//   return this.titleMap[selected] || (selected ? selected.charAt(0).toUpperCase() + selected.slice(1) : '');
// }

  /** Opens dialog to add new entry (logic can be added here later). */
  
     openDialog(){
        const dialogRef = this.dialog.open(AllergyDialogComponent, {
          width: '600px',
          maxWidth: '95vw',
          data: { 
            mode: 'add',
            selected:this.selected
          },
          disableClose: true,
          autoFocus: true,
        
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
           this.loadProfileDetails();
          }
        });
       }
  

  /** Opens the read-only details dialog for the selected record. Its Edit button hands over to the existing edit dialog. */
  onView(data: any): void {
    const dialogRef = this.dialog.open(AllergyDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: {
        mode: 'view',
        details: data,
        selected: this.selected
      },
      autoFocus: 'dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'edit') {
        this.onEdit(data);   // same record, existing edit dialog, existing reload-on-save
      }
    });
  }

  /** Placeholder for edit logic. */
  onEdit(data: any): void {
    const dialogRef = this.dialog.open(AllergyDialogComponent, {
         width: '600px',
         maxWidth: '95vw',
          data: { 
            mode: 'edit',
            details:data,
            selected:this.selected
          },
          disableClose: true,
          autoFocus: true,
        
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.loadProfileDetails();
          }
        });
  }

  /** Placeholder for delete logic. */
  // onDelete(data: any): void {
  //   if(data){
  //      this.authService.del_profile_details_cat(this.selected,data.id).subscribe((res:any)=>{
  //     if(res){
  //       this.loadProfileDetails();
  //     }
  //   })
  //   }
  // }

  onDelete(med: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: `Delete ${this.selected}`,
        message: `Are you sure want to delete this ${this.headerTitle}?`,
        sub: 'You will not be able to recover it once it is deleted.'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && med) {
        this.authService.del_profile_details_cat(this.selected, med.id).subscribe(
          (res: any) => {
            // Remove from local list
            this.loadProfileDetails();
            this.toastr.success(res.msg);
          },
          (error: any) => {
            //console.error('Error deleting medication:', error);
            this.toastr.error('Failed to delete medication');
          }
        );
      }
    });
  }

  goBack(): void {
    this.router.navigate(["/health/dashbord"])
  }
}
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { es } from 'date-fns/locale';
import { Platform } from '@angular/cdk/platform';
import { VG_DATE_PROVIDERS } from '../../vg-datepicker/vg-datepicker';

export class YearOnlyDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (value == null) return null;
    if (typeof value === 'number' && value >= 0) return new Date(value, 0, 1);
    if (value instanceof Date) return new Date(value.getFullYear(), 0, 1);
    if (typeof value === 'string') {
      const m = value.trim().match(/^(\d{4})$/); // accept only YYYY
      if (m) return new Date(+m[1], 0, 1);
    }
    return null; // reject anything that isn't just YYYY
  }

  override format(date: Date, displayFormat: string): string {
    // Always display as YYYY
    return String(date.getFullYear());
  }
}

export const YEAR_ONLY_FORMATS = {
  parse: { dateInput: 'YYYY' },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};

/** One read-only row in the View Details dialog. */
export interface ViewField {
  label: string;
  value: string;     // already formatted; '—' when empty
  empty: boolean;
  full: boolean;     // spans both columns
  docs?: boolean;    // insurance: renders the saved documents instead of text
}

// Allergy dialog component
@Component({
  selector: 'app-allergy-dialog',
  templateUrl: './dialog-allergy-box.html',
  styleUrls: ['./allergy.component.css'],
  providers: VG_DATE_PROVIDERS,   // dates display as "Oct 13, 2026"
  standalone: false
})
export class AllergyDialogComponent {
  myForm: FormGroup;
  dialogMode: string;
  selected_dialog_mode: any;
  allergReactions: any[] = [];
  medlist: any[] = [];
  immunization: any[] = [];
  fam_historty_list = ['mother', 'father', 'son', 'daughter', 'friend', 'others'];
  filteredConditions: any[] = [];
  submitted = false;

  // Year dropdown for "Year of Diagnosis" (current year down to 1900)
  currentYear = new Date().getFullYear();
  years: number[] = Array.from({ length: this.currentYear - 1900 + 1 }, (_, i) => this.currentYear - i);

  // Date pickers: form values are Date objects, limits are local-midnight Dates (the API still gets MM-dd-yyyy, see onSubmit)
  today: Date = this.startOfDay(new Date());
  tomorrow: Date = this.addDays(this.startOfDay(new Date()), 1);
  /** Min for End Date / Next Due Date. A date that is already saved on the record is never rejected, so editing an old record can still be saved. */
  endMin: Date = this.tomorrow;
  nextDueMin: Date = this.tomorrow;

  // Treats null / undefined / '' as the same "empty" value for native <select>s
  sameValue = (a: unknown, b: unknown): boolean => (a ?? '') === (b ?? '');

  // ---- multi-select dropdowns (Allergic Reactions / Relationship) ----
  openMulti: string | null = null;

  toggleOpen(name: string, ev: Event): void {
    ev.stopPropagation();
    if (this.openMulti === name) {
      this.closeMulti();
      return;
    }
    this.closeMulti();
    this.openMulti = name;
    const host = (ev.currentTarget as HTMLElement).parentElement;
    // make sure the opened list is visible inside the scrolling body
    setTimeout(() => host?.querySelector('.multi-panel')?.scrollIntoView({ block: 'nearest' }), 0);
  }

  @HostListener('document:click')
  @HostListener('document:keydown.escape')
  closeMulti(): void {
    if (this.openMulti) {
      this.myForm.get(this.openMulti)?.markAsTouched(); // so the required error can show
      this.openMulti = null;
    }
  }

  selectedValues(name: string): string[] {
    const v = this.myForm.get(name)?.value;
    return Array.isArray(v) ? v : (v ? [v] : []);
  }

  // ---- searchable dropdown (Condition Name) ----
  activeIndex = -1;

  /** Row index of the pinned "Others" entry in the condition list. */
  get othersIndex(): number {
    return Math.min((this.filteredConditions || []).length, 100);
  }

  openCombo(name: string): void {
    if (this.openMulti !== name) {
      this.closeMulti();
      this.openMulti = name;
    }
  }

  pickCondition(title: string): void {
    const ctrl = this.myForm.get('conditionName');
    ctrl?.markAsDirty();
    ctrl?.markAsTouched();
    ctrl?.setValue(title);
    this.openMulti = null;
    this.activeIndex = -1;
  }

  onComboKey(e: KeyboardEvent): void {
    const list = (this.filteredConditions || []).slice(0, 100);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.openMulti = 'conditionName';
      this.activeIndex = Math.min(list.length, this.activeIndex + 1); // list.length = the pinned "Others" row
      this.scrollActiveIntoView();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.activeIndex = Math.max(0, this.activeIndex - 1);
      this.scrollActiveIntoView();
    } else if (e.key === 'Enter' && this.openMulti === 'conditionName' && this.activeIndex >= 0) {
      e.preventDefault();
      this.pickCondition(this.activeIndex >= list.length ? 'Others' : list[this.activeIndex].title);
    } else if (e.key === 'Tab') {
      this.closeMulti();
    }
  }

  private scrollActiveIntoView(): void {
    setTimeout(() => document.querySelector('.combo-option.active')?.scrollIntoView({ block: 'nearest' }), 0);
  }

  selectedText(name: string, placeholder: string): string {
    const sel = this.selectedValues(name);
    return sel.length ? sel.map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(', ') : placeholder;
  }
  selyear = new Date();
  minyear = new Date(1990,1,1)
  // Insurance documents: files picked in the upload row (sent with the Health category document API when the form is saved)
  insuranceDocs: File[] = [];
  insuranceSavedDocs: { id: string; name: string; url: string }[] = [];   // edit mode: documents already stored for this insurance
  isUploading = false;
  insuranceDocsLoading = false;   // View Details only: true until the saved-documents lookup has finished
  private readonly docCountry = 'citizen_primary';

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AllergyDialogComponent>,
    public auth: AuthService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: { mode: 'add' | 'edit' | 'view'; selected: any; details?: any }
  ) {
    this.dialogMode = data.mode;
    this.selected_dialog_mode = data.selected;
    // View mode is read-only: no form controls and none of the form's lookup API calls
    this.myForm = this.dialogMode === 'view'
      ? this.formBuilder.group({})
      : this.initForm(this.selected_dialog_mode, data.details || {});
    this.viewFields = this.dialogMode === 'view' ? this.buildViewFields(this.selected_dialog_mode, data.details || {}) : [];
    this.setupDateLimits(data.details || {});
    if ((this.dialogMode === 'edit' || this.dialogMode === 'view') && this.selected_dialog_mode === 'insurance' && data.details?.id) {
      this.insuranceDocsLoading = this.dialogMode === 'view';
      this.loadInsuranceDocs(String(data.details.id));
    }

    // "Others" option: show/require a text input only while Others is chosen
    this.watchOther('vaccineName', 'vaccineOther');
    this.watchOther('allergicReaction', 'reactionOther');
    this.watchOther('conditionName', 'conditionOther');
    this.watchOther('relationship', 'relationshipOther');
  }

  ngOnInit(): void {
    if (this.dialogMode === 'view') { return; }
    this.getMedicalConditions();
    this.myForm.get('conditionName')?.valueChanges.subscribe(value => {
      const filterValue = (value || '').toLowerCase();
      this.filteredConditions = this.medlist?.filter((condition: any) =>
        condition.title.toLowerCase().includes(filterValue)
      );
    });
  }

  // ---------- helpers used by the template ----------

  /** Opens the native date picker when a date input is clicked. */
  openPicker(event: Event): void {
    try { (event.target as HTMLInputElement).showPicker?.(); } catch { }
  }

  /** Is `val` selected in a multi-value control (allergicReaction / relationship)? */
  isChecked(controlName: string, val: string): boolean {
    const v = this.myForm.get(controlName)?.value;
    return Array.isArray(v) ? v.includes(val) : v === val;
  }

  /** Dropdown option toggled: add / remove `val` from the control's array value. */
  toggleMulti(controlName: string, val: string, checked: boolean): void {
    const ctrl = this.myForm.get(controlName);
    if (!ctrl) return;
    const current: string[] = Array.isArray(ctrl.value) ? [...ctrl.value] : (ctrl.value ? [ctrl.value] : []);
    const next = checked
      ? (current.includes(val) ? current : [...current, val])
      : current.filter(x => x !== val);
    ctrl.markAsDirty();
    ctrl.markAsTouched();
    ctrl.setValue(next);
  }

  /** Sets End Date / Next Due Date limits: End Date must be after Start Date (or tomorrow). */
  private setupDateLimits(details: any): void {
    const savedEnd = this.toLocalDate(details?.endDate);
    const savedNext = this.toLocalDate(details?.nextDueDate);
    if (savedNext && savedNext < this.tomorrow) { this.nextDueMin = savedNext; }

    const calcEndMin = (start: Date | null): Date => {
      const base = start ? this.addDays(start, 1) : this.tomorrow;
      return savedEnd && savedEnd < base ? savedEnd : base;
    };
    const startCtrl = this.myForm.get('startDate');
    this.endMin = calcEndMin(this.toLocalDate(startCtrl?.value));
    startCtrl?.valueChanges.subscribe(v => { this.endMin = calcEndMin(this.toLocalDate(v)); });
  }

  private startOfDay(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  private addDays(d: Date, days: number): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + days);
  }

  /** Accepts Date | 'MM-dd-yyyy' | 'yyyy-MM-dd' | ISO and returns a local-midnight Date (or null). No UTC conversion, so no day shift. */
  private toLocalDate(value: any): Date | null {
    if (!value) return null;
    let d: Date;
    if (value instanceof Date) {
      d = value;
    } else if (typeof value === 'string') {
      const us = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);       // MM-dd-yyyy (backend format)
      const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})/);           // yyyy-MM-dd[...]
      if (us) {
        d = new Date(+us[3], +us[1] - 1, +us[2]);
      } else if (iso) {
        d = new Date(+iso[1], +iso[2] - 1, +iso[3]);
      } else {
        d = new Date(value);
      }
    } else {
      d = new Date(value);
    }
    return isNaN(d.getTime()) ? null : this.startOfDay(d);
  }

  getError(controlName: string): string | null {
    const control = this.myForm.get(controlName);

    if (!control || !control.errors || !control.touched) {
      return null; // only show errors when touched
    }

    if (control.errors['required']) {
      return 'This field is required';
    }

    if (control.errors['minlength']) {
      return `Minimum length is ${control.errors['minlength'].requiredLength}`;
    }

    if (control.errors['maxlength']) {
      return `Maximum length is ${control.errors['maxlength'].requiredLength}`;
    }

    if (control.errors['min']) {
      return `Minimum value is ${control.errors['min'].min}`;
    }

    if (control.errors['max']) {
      return `Maximum value is ${control.errors['max'].max}`;
    }

    if (control.errors['pattern']) {
      return 'Invalid format';
    }

    if (control.errors['matDatepickerMin']) {
      return 'Choose a later date';
    }

    if (control.errors['matDatepickerMax']) {
      return 'Choose today or an earlier date';
    }

    if (control.errors['matDatepickerParse']) {
      return 'Enter a valid date';
    }

    return null;
  }

  private initForm(type: any, details: any): FormGroup {
    switch (type) {
      case 'medicalcondition': {
        this.getMedicalConditions();
        const year = Number(details?.yearOfDiagnosis);
        return this.formBuilder.group({
          conditionName: [details.conditionName || '', Validators.required],
          yearOfDiagnosis: [
            Number.isFinite(year) && year > 0 ? year : this.currentYear,
            [Validators.required, Validators.min(1900), Validators.max(this.currentYear)]
          ],
          comment: [details.comment || '']
        });
      }

      case 'allergy':
        this.getAllergicReactions();
        return this.formBuilder.group({
          allergicTo: [details.allergicTo || '', Validators.required],
          allergicReaction: [details.allergicReaction || [], Validators.required],
          severity: [details.severity?.toLowerCase() || '', Validators.required],
          reactionOther: [''],
          comment: [details.comment || '']
        });

      case 'familyhistory': {
        this.getMedicalConditions();
        const rel: string[] = Array.isArray(details.relationship)
          ? details.relationship
          : (details.relationship ? [details.relationship] : []);
        const known = rel.filter(x => this.fam_historty_list.includes(String(x).toLowerCase()));
        const custom = rel.filter(x => !this.fam_historty_list.includes(String(x).toLowerCase()));
        return this.formBuilder.group({
          conditionName: [details.conditionName || '', Validators.required],
          conditionOther: [''],
          // a saved relationship that is not in the list is shown under "Others"
          relationship: [custom.length && !known.some(x => this.isOthers(x)) ? [...known, 'others'] : known, Validators.required],
          relationshipOther: [custom.join(', ')],
          comment: [details.comment || '']
        });
      }

      case 'insurance':
        return this.formBuilder.group({
          insuranceCompany: [details.insuranceCompany || '', Validators.required],
          policyNumber: [details.policyNumber || '', Validators.required],
          memberId: [details.memberId || ''],
          groupNumber: [details.groupNumber || ''],
          startDate: [this.toLocalDate(details?.startDate)],
          endDate: [this.toLocalDate(details?.endDate)],
          planName: [details.planName || '', Validators.required],
          status: [details?.status ? details.status.toLowerCase() : '', Validators.required],
          comment: [details.comment || '']
        });

      case 'immunization':
        this.getImmunization();
        return this.formBuilder.group({
          vaccineName: [details.vaccineName || '', Validators.required],
          vaccineOther: [''],
          adminDate: [this.toLocalDate(details.adminDate), Validators.required],
          nextDueDate: [this.toLocalDate(details.nextDueDate)],
          detail: [details.detail || '']
        });

      default:
        return this.formBuilder.group({});
    }
  }

  // ---------- "Others" option ----------
  isOthers(v: any): boolean {
    return String(v ?? '').trim().toLowerCase() === 'others';
  }

  /** Is "Others" currently chosen in this control (single or multi)? */
  hasOther(name: string): boolean {
    const v = this.myForm.get(name)?.value;
    return Array.isArray(v) ? v.some(x => this.isOthers(x)) : this.isOthers(v);
  }

  /** Requires (and focuses) the companion text input only while "Others" is selected. */
  private watchOther(name: string, otherName: string): void {
    const ctrl = this.myForm.get(name);
    const other = this.myForm.get(otherName);
    if (!ctrl || !other) return;
    let was = this.hasOther(name);
    const apply = (fromUser: boolean) => {
      const now = this.hasOther(name);
      if (now) {
        other.setValidators(Validators.required);
      } else {
        other.clearValidators();
        other.setValue('', { emitEvent: false });
      }
      other.updateValueAndValidity({ emitEvent: false });
      if (fromUser && now && !was && ctrl.dirty) {
        setTimeout(() => document.getElementById(otherName)?.focus(), 0);
      }
      was = now;
    };
    ctrl.valueChanges.subscribe(() => apply(true));
    apply(false);
  }

  /** Replaces "Others" with what the user typed (comma separated for multi-selects). */
  private applyOther(value: any, key: string, otherKey: string, multi: boolean): void {
    if (key in value) {
      const text = String(value[otherKey] ?? '').trim();
      if (multi) {
        const base: string[] = (Array.isArray(value[key]) ? value[key] : []).filter((x: any) => !this.isOthers(x));
        const extra = text ? text.split(',').map(t => t.trim()).filter(Boolean) : [];
        value[key] = this.hasOther(key) ? [...base, ...extra] : base;
      } else if (this.isOthers(value[key])) {
        value[key] = text;
      }
    }
    delete value[otherKey];
  }

  /** Edit mode: a saved reaction that is not in the list is shown under "Others". */
  private prefillCustomReactions(): void {
    const ctrl = this.myForm.get('allergicReaction');
    if (this.dialogMode !== 'edit' || !ctrl || !this.allergReactions.length) return;
    const cur: string[] = Array.isArray(ctrl.value) ? ctrl.value : [];
    const known = cur.filter(x => this.allergReactions.some(r => r.title === x));
    const custom = cur.filter(x => !known.includes(x) && !this.isOthers(x));
    if (custom.length) {
      this.myForm.patchValue({ allergicReaction: [...known, 'Others'], reactionOther: custom.join(', ') });
    }
  }

  /** Edit mode: a saved vaccine that is not in the list is shown under "Others". */
  private prefillCustomVaccine(): void {
    const ctrl = this.myForm.get('vaccineName');
    const cur = ctrl?.value;
    if (this.dialogMode !== 'edit' || !ctrl || !cur || this.isOthers(cur) || !this.immunization.length) return;
    if (!this.immunization.some(v => v.title === cur)) {
      this.myForm.patchValue({ vaccineName: 'Others', vaccineOther: cur });
    }
  }

  getAllergicReactions(): void {
    this.auth.get_allergic_reaction().subscribe({
      next: (res: any) => {
        this.allergReactions = res?.data.allergy || [];
        this.prefillCustomReactions();
      },
      error: () => this.toastr.error('Failed to load allergic reactions')
    });
  }

  getMedicalConditions() {
    this.auth.get_medical_condition().subscribe({
      next: (res: any) => {
        this.medlist = res?.data?.medicalcondition || [];
        this.filteredConditions = this.medlist; // suggestions available before the first keystroke
      },
      error: () => this.toastr.error('Failed to load medical conditions')
    });
  }

  getImmunization() {
    this.auth.get_vaccine_list().subscribe((res: any) => {
      if (res) {
        this.immunization = res.data.vaccine;
        this.prefillCustomVaccine();
      }
    });
  }

  onSubmit(): void {
    if (this.isUploading) { return; }
    this.submitted = true;
    if (this.myForm.invalid) {
      this.myForm.markAllAsTouched();
      return;
    }

    // Date objects (date pickers) -> MM-dd-yyyy (what the API expects; empty stays '' as before)
    const formattedFormValue = { ...this.myForm.value };

    // replace "Others" with what the user typed; the helper *Other controls are not sent
    this.applyOther(formattedFormValue, 'vaccineName', 'vaccineOther', false);
    this.applyOther(formattedFormValue, 'conditionName', 'conditionOther', false);
    this.applyOther(formattedFormValue, 'allergicReaction', 'reactionOther', true);
    this.applyOther(formattedFormValue, 'relationship', 'relationshipOther', true);
    for (const key of ['startDate', 'endDate', 'adminDate', 'nextDueDate']) {
      if (!(key in formattedFormValue)) { continue; }
      const value = formattedFormValue[key];
      formattedFormValue[key] = value ? (this.datePipe.transform(value, 'MM-dd-yyyy') ?? '') : '';
    }

    // Insurance only: after the record is saved, the picked files go to the Health document API (see uploadInsuranceDocs)
    const afterSave = (insuranceId: Observable<string>) => {
      if (this.selected_dialog_mode !== 'insurance' || !this.insuranceDocs.length) {
        this.dialogRef.close(formattedFormValue);
        return;
      }
      this.isUploading = true;
      insuranceId.pipe(
        switchMap(id => id ? this.uploadInsuranceDocs(id) : of({ ok: 0, failed: this.insuranceDocs.length }))
      ).subscribe(r => {
        this.isUploading = false;
        if (r.failed) { this.toastr.error(`Insurance saved, but ${r.failed} document(s) could not be uploaded.`, 'Upload Error'); }
        else { this.toastr.success(`${r.ok} document(s) uploaded successfully.`); }
        this.dialogRef.close(formattedFormValue);
      });
    };

    if (this.dialogMode === 'add') {
      this.auth.add_profile_details_cat(this.selected_dialog_mode, formattedFormValue).subscribe((res: any) => {
        if (res) {
          this.toastr.success(res.msg);
          afterSave(this.resolveInsuranceId(res, formattedFormValue));
        }
      });
    } else {
      this.auth.update_profile_details_cat(this.selected_dialog_mode, this.data.details.id, formattedFormValue).subscribe((res: any) => {
        if (res) {
          this.toastr.success(res.msg);
          afterSave(of(String(this.data.details.id)));
        }
      });
    }
  }

  // ---------- Insurance documents (Health category document API) ----------

  /** Subtag that links a document to one insurance record: Health-<insurance id>. */
  private insuranceSubtag(insuranceId: string): string {
    return `Health-${insuranceId}`;
  }

  /** Id of the Health category, from the same category API the Documents module uses ('' when it cannot be found). */
  private healthCategoryId(): Observable<string> {
    return this.auth.get_tags(this.docCountry).pipe(
      map((r: any) => {
        const cat = (r?.data?.categories || []).find((c: any) => String(c?.tagname || '').toLowerCase() === 'health');
        return cat?.id ? String(cat.id) : '';
      }),
      catchError(() => of(''))
    );
  }

  /**
   * Id of the insurance record that was just added. Uses the id of the add response when it has one;
   * otherwise looks the record up in the insurance list (same company + policy number, newest first).
   */
  private resolveInsuranceId(res: any, formValue: any): Observable<string> {
    const direct = res?.data?.id ?? res?.id ?? res?.data?.insurance?.id;
    if (direct) { return of(String(direct)); }
    return this.auth.profile_details_cat('insurance').pipe(
      map((r: any) => {
        const list: any[] = r?.data?.insurance || [];
        const match = list.filter(i => i?.insuranceCompany === formValue.insuranceCompany && i?.policyNumber === formValue.policyNumber);
        return match.length ? String(match[match.length - 1].id) : '';
      }),
      catchError(() => of(''))
    );
  }

  /**
   * Uploads the picked files with the existing personal-document API (POST consumer/v3/personal/citizen_primary/add):
   * tags = [Health category id], subtags = ['Health-<insurance id>'], user_tags = ['Insurance'].
   */
  private uploadInsuranceDocs(insuranceId: string): Observable<{ ok: number; failed: number }> {
    const files = [...this.insuranceDocs];
    const company = this.myForm.value?.insuranceCompany || '';
    return this.healthCategoryId().pipe(
      switchMap(healthId => {
        if (!healthId) { return of({ ok: 0, failed: files.length }); }
        return forkJoin(files.map(file => {
          const fd = new FormData();
          fd.append('name', file.name.replace(/\.[^.]+$/, ''));
          fd.append('description', `Insurance document${company ? ' - ' + company : ''}`);
          fd.append('expiration_date', '');
          fd.append('tags', JSON.stringify([healthId]));
          fd.append('subtags', JSON.stringify([this.insuranceSubtag(insuranceId)]));
          fd.append('user_tags', JSON.stringify(['Insurance']));
          fd.append('file', file);
          return this.auth.add_personal_doc(this.docCountry, fd).pipe(
            map((r: any) => r?.error === false),
            catchError(() => of(false))
          );
        })).pipe(map(results => ({ ok: results.filter(Boolean).length, failed: results.filter(r => !r).length })));
      })
    );
  }

  /** Edit mode: documents already stored for this insurance - GET .../tagged/citizen_primary/<Health category id>/Health-<insurance id>. */
  private loadInsuranceDocs(insuranceId: string): void {
    this.healthCategoryId().subscribe(healthId => {
      if (!healthId) { this.insuranceDocsLoading = false; return; }
      this.auth.get_personal_docs_tag_insurance(healthId, this.docCountry, this.insuranceSubtag(insuranceId)).subscribe({
        next: (res: any) => {
          const docs: any[] = res?.data?.documents || [];
          this.insuranceSavedDocs = docs.filter(d => d?.url).map(d => ({ id: d.id, name: d.name || d.filename || 'Document', url: d.url }));
          this.insuranceDocsLoading = false;
          this.cdr.detectChanges();
        },
        error: () => { /* the saved-documents row simply stays hidden */ this.insuranceDocsLoading = false; this.cdr.detectChanges(); }
      });
    });
  }

  openSavedInsuranceDoc(doc: { url: string }): void {
    window.open(doc.url, '_blank', 'noopener');
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  // ---------- View Details (read-only) ----------
  viewFields: ViewField[] = [];

  /** Header text: 'Add Allergy' / 'Edit Allergy' as before, 'Allergy Details' in view mode. */
  get dialogTitle(): string {
    const name = this.getDialogTitle(this.selected_dialog_mode);
    if (this.dialogMode === 'view') { return `${name} Details`; }
    return `${this.dialogMode === 'add' ? 'Add' : 'Edit'} ${name}`;
  }

  /** View Details -> Edit: closes this dialog; the list opens the existing edit dialog for the same record. */
  onEditFromView(): void {
    this.dialogRef.close('edit');
  }

  private viewText(v: unknown): string {
    if (v === null || v === undefined) { return ''; }
    const s = String(v).trim();
    return (s === 'null' || s === 'undefined' || s === 'NaN') ? '' : s;
  }

  private viewCap(s: string): string {
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }

  /** Array or single value -> 'a, b'. */
  private viewList(v: unknown, capitalize = false): string {
    const list = Array.isArray(v) ? v : (v ? [v] : []);
    return list.map(x => this.viewText(x)).filter(x => x.length > 0)
      .map(x => capitalize ? this.viewCap(x) : x).join(', ');
  }

  /** 'MM-dd-yyyy' (API) or 'yyyy-MM-dd[...]' -> 'Oct 13, 2026'. Parsed by hand, so there is no timezone shift. */
  private viewDate(v: unknown): string {
    const s = this.viewText(v);
    if (!s) { return ''; }
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let y = 0, m = 0, d = 0;
    const us = s.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (us) { m = +us[1]; d = +us[2]; y = +us[3]; }
    else if (iso) { y = +iso[1]; m = +iso[2]; d = +iso[3]; }
    return (m >= 1 && m <= 12 && d >= 1 && d <= 31) ? `${months[m - 1]} ${d}, ${y}` : s;   // unrecognised: show as returned
  }

  /** Builds the read-only rows from the record the list passed in (same fields the edit form uses). */
  private buildViewFields(type: string, d: any): ViewField[] {
    const f = (label: string, value: string, full = false): ViewField =>
      ({ label, value: value || '—', empty: !value, full });
    const text = (v: unknown) => this.viewText(v);
    const title = (v: unknown) => this.viewCap(this.viewText(v).toLowerCase());

    switch (type) {
      case 'allergy':
        return [
          f('Allergen / Allergy Name', text(d.allergicTo)),
          f('Severity', title(d.severity)),
          f('Reaction', this.viewList(d.allergicReaction), true),
          f('Additional Notes', text(d.comment), true)
        ];
      case 'insurance':
        return [
          f('Insurance Company', text(d.insuranceCompany)),
          f('Policy Number', text(d.policyNumber)),
          f('Member ID', text(d.memberId)),
          f('Group Number', text(d.groupNumber)),
          f('Start Date', this.viewDate(d.startDate)),
          f('End Date', this.viewDate(d.endDate)),
          f('Plan Name', text(d.planName)),
          f('Status', title(d.status)),
          { label: 'Uploaded Documents', value: '', empty: false, full: true, docs: true },
          f('Additional Notes', text(d.comment), true)
        ];
      case 'immunization':
        return [
          f('Vaccine Name', text(d.vaccineName), true),
          f('Administered Date', this.viewDate(d.adminDate)),
          f('Next Due Date', this.viewDate(d.nextDueDate)),
          f('Additional Notes', text(d.detail), true)
        ];
      case 'familyhistory':
        return [
          f('Condition Name', text(d.conditionName)),
          f('Relationship', this.viewList(d.relationship, true)),
          f('Additional Notes', text(d.comment), true)
        ];
      case 'medicalcondition':
        return [
          f('Condition Name', text(d.conditionName)),
          f('Year of Diagnosis', text(d.yearOfDiagnosis)),
          f('Additional Notes', text(d.comment), true)
        ];
      default:
        return [];
    }
  }
  /** Add Insurance: adds the chosen files to the list (same file is not added twice). */
  onInsuranceFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    for (const f of Array.from(input.files ?? [])) {
      const exists = this.insuranceDocs.some(d => d.name === f.name && d.size === f.size && d.lastModified === f.lastModified);
      if (!exists) { this.insuranceDocs.push(f); }
    }
    input.value = '';   // lets the user pick the same file again after removing it
  }

  removeInsuranceDoc(index: number): void {
    this.insuranceDocs.splice(index, 1);
  }

  clearInsuranceDocs(): void {
    this.insuranceDocs = [];
  }

//   end_min_value(start: Date) {
//   if (start) {
//     const sdate = new Date(start);
//     sdate.setDate(sdate.getDate() + 1); // add 1 day
//     return sdate;
//   }
//   return this.tomorrow;
// }


  getDialogTitle(mode: string): string {
    switch (mode) {
      case 'familyhistory':
        return 'Family History';
      case 'medicalcondition':
        return 'Medical Condition';
      default:
        // fallback: capitalize first letter of each word
        return mode.replace(/([a-z])([A-Z])/g, '$1 $2') // handles camelCase
          .replace(/_/g, ' ')                           // handles snake_case
          .replace(/\b\w/g, char => char.toUpperCase());
    }
  }

}